import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/zora.peteri/projects/react-tweet-card/node_modules/gatsby-theme-docz/src/base/Layout.js";
import TweetCard from './TweetCard';
import ThemeHandler from './ThemeHandler';
import Container from './components/Container';
import { Playground } from 'docz';
import { Code } from 'gatsby-theme-docz/src/components/Code';
export const author = {
  name: 'olive 🍓🐇',
  username: 'milkandmorphine',
  image: 'https://pbs.twimg.com/profile_images/1407804739094515713/_9SvjNSI_400x400.jpg'
};
export const tweet = `hate restaurants that make u say shit like yeah can i have the big wet daddy burger please thanks`;
export const time = new Date(2021, 5, 23, 13, 51);
export const source = "Twitter for iPhone";
export const permalink = "https://twitter.com/milkandmorphine/status/1407667588189065217";
export const fitInsideContainer = true;
export const _frontmatter = {};
const layoutProps = {
  author,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ThemeHandler mdxType="ThemeHandler" />

    <h1 {...{
      "id": "styling"
    }}>{`Styling`}</h1>
    <h2 {...{
      "id": "themes"
    }}>{`Themes`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`theme`}</inlineCode>{` prop can be set to `}<inlineCode parentName="p">{`light`}</inlineCode>{`, `}<inlineCode parentName="p">{`dim`}</inlineCode>{`, or `}<inlineCode parentName="p">{`dark`}</inlineCode>{`. Try it out!`}</p>
    <Playground __position={1} __code={'<Container>\n  <TweetCard\n    {...{ author, tweet, time, source, permalink, fitInsideContainer }}\n    theme=\"dim\" // try \"light\" and \"dark\"\n  />\n</Container>'} __scope={{
      props,
      DefaultLayout,
      TweetCard,
      ThemeHandler,
      Container,
      Playground,
      Code,
      DefaultLayout,
      author,
      tweet,
      time,
      source,
      permalink,
      fitInsideContainer,
      _frontmatter
    }} showPlaygroundEdit={false} mdxType="Playground">
    <Container mdxType="Container">
        <TweetCard {...{
          author,
          tweet,
          time,
          source,
          permalink,
          fitInsideContainer
        }} theme="dim" // try "light" and "dark"
        mdxType="TweetCard" />
    </Container>
    </Playground>
    <h2 {...{
      "id": "colors"
    }}>{`Colors`}</h2>
    <p>{`The colors of the pre-defined themes can be extended.`}</p>
    <table>
    <thead>
        <tr>
            <th>Color setting</th>
            <th>Used</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>primary</td>
            <td>Author name, tweet text</td>
        </tr>
        <tr>
            <td>secondary</td>
            <td>Author username, time</td>
        </tr>
        <tr>
            <td>accent</td>
            <td>Source, mentions, links</td>
        </tr>
        <tr>
            <td>background</td>
            <td>Background color of the container</td>
        </tr>
    </tbody>
    </table>
    <Playground __position={3} __code={'<Container>\n  <TweetCard\n    {...{ author, tweet, time, source, permalink, fitInsideContainer }}\n    colors={{\n      primary: \'#ffffff\',\n      secondary: \'#add8e6\',\n      accent: \'#ffffd8\',\n      background: \'#e5e4ff\',\n    }}\n  />\n</Container>'} __scope={{
      props,
      DefaultLayout,
      TweetCard,
      ThemeHandler,
      Container,
      Playground,
      Code,
      DefaultLayout,
      author,
      tweet,
      time,
      source,
      permalink,
      fitInsideContainer,
      _frontmatter
    }} showPlaygroundEdit={false} mdxType="Playground">
    <Container mdxType="Container">
        <TweetCard {...{
          author,
          tweet,
          time,
          source,
          permalink,
          fitInsideContainer
        }} colors={{
          primary: '#ffffff',
          secondary: '#add8e6',
          accent: '#ffffd8',
          background: '#e5e4ff'
        }} mdxType="TweetCard" />
    </Container>
    </Playground>
    <h2 {...{
      "id": "gradient-background"
    }}>{`Gradient background`}</h2>
    <p>{`Passing in the `}<inlineCode parentName="p">{`gradientBackground`}</inlineCode>{` prop to the component will create a gradient background to the container based on the background color of the active theme.`}</p>
    <Playground __position={4} __code={'<Container>\n  <TweetCard\n    {...{ author, tweet, time, source, permalink, fitInsideContainer }}\n    theme=\"light\" // try \"dim\" and \"dark\"\n    gradientBackground\n  />\n</Container>'} __scope={{
      props,
      DefaultLayout,
      TweetCard,
      ThemeHandler,
      Container,
      Playground,
      Code,
      DefaultLayout,
      author,
      tweet,
      time,
      source,
      permalink,
      fitInsideContainer,
      _frontmatter
    }} showPlaygroundEdit={false} mdxType="Playground">
    <Container mdxType="Container">
        <TweetCard {...{
          author,
          tweet,
          time,
          source,
          permalink,
          fitInsideContainer
        }} theme="light" // try "dim" and "dark"
        gradientBackground mdxType="TweetCard" />
    </Container>
    </Playground>
    <h2 {...{
      "id": "blurred-background"
    }}>{`Blurred background`}</h2>
    <p>{`Passing in the `}<inlineCode parentName="p">{`blurredBackground`}</inlineCode>{` prop to the component will create a blurred effect on the background of the container.`}</p>
    <Playground __position={5} __code={'<Container>\n  <TweetCard\n    {...{ author, tweet, time, source, permalink, fitInsideContainer }}\n    theme=\"light\" // try \"dim\" and \"dark\"\n    blurredBackground\n  />\n</Container>'} __scope={{
      props,
      DefaultLayout,
      TweetCard,
      ThemeHandler,
      Container,
      Playground,
      Code,
      DefaultLayout,
      author,
      tweet,
      time,
      source,
      permalink,
      fitInsideContainer,
      _frontmatter
    }} showPlaygroundEdit={false} mdxType="Playground">
    <Container mdxType="Container">
        <TweetCard {...{
          author,
          tweet,
          time,
          source,
          permalink,
          fitInsideContainer
        }} theme="light" // try "dim" and "dark"
        blurredBackground mdxType="TweetCard" />
    </Container>
    </Playground>
    <h2 {...{
      "id": "accessing-the-dom-node"
    }}>{`Accessing the DOM node`}</h2>
    <p>{`Any prop that's a valid HTML5 attribute can be passed in to the component, and its main div will get those attributes, including `}<inlineCode parentName="p">{`className`}</inlineCode>{` and `}<inlineCode parentName="p">{`style`}</inlineCode>{`. This way the component can easily be used with libraries like styled components.`}</p>
    <Playground __position={6} __code={'<Container>\n  <TweetCard\n    {...{ author, tweet, time, source, permalink, fitInsideContainer }}\n    style={{\n      transform: \'rotate(5deg)\',\n    }}\n  />\n</Container>'} __scope={{
      props,
      DefaultLayout,
      TweetCard,
      ThemeHandler,
      Container,
      Playground,
      Code,
      DefaultLayout,
      author,
      tweet,
      time,
      source,
      permalink,
      fitInsideContainer,
      _frontmatter
    }} showPlaygroundEdit={false} mdxType="Playground">
    <Container mdxType="Container">
        <TweetCard {...{
          author,
          tweet,
          time,
          source,
          permalink,
          fitInsideContainer
        }} style={{
          transform: 'rotate(5deg)'
        }} mdxType="TweetCard" />
    </Container>
    </Playground>
    <h2 {...{
      "id": "classnames"
    }}>{`Classnames`}</h2>
    <p>{`The component intentionally exposes classnames on its elements for you to control from your own stylesheet. All classnames start with the `}<inlineCode parentName="p">{`react-tweet-card`}</inlineCode>{` prefix.`}</p>
    <details style={{
      fontSize: '14px'
    }}>
    <summary style={{
        "cursor": "pointer",
        "padding": "10px",
        "border": "1px solid currentColor",
        "borderRadius": "4px",
        "width": "fit-content",
        "margin": "10px 0"
      }}>
        Exposed classnames
    </summary>
    <ul style={{
        "marginLeft": "50px"
      }}>
        <li>react-tweet-card__container</li>
        <li>react-tweet-card__author-name</li>
        <li>react-tweet-card__author-username</li>
        <li>react-tweet-card__author-image</li>
        <li>react-tweet-card__verified-badge</li>
        <li>react-tweet-card__protected-icon</li>
        <li>react-tweet-card__time</li>
        <li>react-tweet-card__source</li>
        <li>react-tweet-card__tweet</li>
        <li>react-tweet-card__imageContainer</li>
        <li>react-tweet-card__image</li>
        <li>react-tweet-card__twitter-logo</li>
        <li>react-tweet-card__engagement-container</li>
        <li>react-tweet-card__replies</li>
        <li>react-tweet-card__retweets</li>
        <li>react-tweet-card__likes</li>
    </ul>
    </details>
    <Code className="css" mdxType="Code">
    {`/* example */
    
.react-tweet-card__username {
    display: none;
}`}
    </Code>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      